import React from 'react';
import influencerLogo from '../../assets/influencer-logo.png';
import youtubeLogo from '../../assets/youtube-logo.png';

/**
 * Branded wrapper for the public legal pages (Privacy Policy, Terms).
 * Includes Influencer branding + YouTube API Services branding in the header,
 * so screenshots of these pages clearly show YouTube branding for compliance.
 */
const NAVY = '#111936';
const INK = '#1f2433';
const MUTED = '#6b7280';
const GOLD = '#febd1c';

const LegalPage = ({ title, updated, children }) => (
  <div
    style={{
      minHeight: '100vh',
      background: '#eef1f7',
      fontFamily: "'Inter', -apple-system, 'Segoe UI', Roboto, system-ui, sans-serif",
      color: INK,
      paddingBottom: '64px',
    }}
  >
    {/* Header / branding */}
    <header
      style={{
        background: '#ffffff',
        color: INK,
        padding: '20px 24px',
        borderBottom: '1px solid #e4e7ef',
      }}
    >
      <div
        style={{
          maxWidth: '860px',
          margin: '0 auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '16px',
          flexWrap: 'wrap',
        }}
      >
        <img src={influencerLogo} alt="Influencer.in" style={{ height: '30px' }} />
        <span
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            fontSize: '13px',
            color: '#000000',
            background: '#f6f7fb',
            border: '1px solid #e4e7ef',
            borderRadius: '999px',
            padding: '6px 12px',
          }}
        >
          Works with
          <img src={youtubeLogo} alt="YouTube" style={{ height: '16px', display: 'block' }} />
          API Services
        </span>
      </div>
    </header>

    {/* Body card */}
    <main
      style={{
        maxWidth: '860px',
        margin: '24px auto',
        background: '#fff',
        borderRadius: '16px',
        boxShadow: '0 20px 60px -30px rgba(17,25,54,0.4)',
        padding: '36px 40px',
      }}
    >
      <h1 style={{ color: NAVY, fontSize: '30px', margin: '0 0 6px' }}>{title}</h1>
      <div
        style={{
          height: '3px',
          width: '54px',
          background: GOLD,
          borderRadius: '3px',
          margin: '0 0 10px',
        }}
      />
      {updated ? (
        <p style={{ color: MUTED, fontSize: '13px', margin: '0 0 24px' }}>Last updated: {updated}</p>
      ) : null}
      <div style={{ fontSize: '15px', lineHeight: 1.7 }}>{children}</div>
    </main>

    <p style={{ textAlign: 'center', color: MUTED, fontSize: '12px', margin: '0 24px' }}>
      © {new Date().getFullYear()} Influencer.in · A product of Social Beat
    </p>
  </div>
);

export const H2 = ({ children }) => (
  <h2 style={{ color: NAVY, fontSize: '19px', margin: '28px 0 8px' }}>{children}</h2>
);

export const P = ({ children }) => <p style={{ margin: '0 0 12px' }}>{children}</p>;

export const A = ({ href, children }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" style={{ color: '#232f63', fontWeight: 600 }}>
    {children}
  </a>
);

export default LegalPage;
